interface Comment {
  name: string;
  avatar: string;
  time: string;
  content: string;
  movie: string;
  rating: number;
}

const comments: Comment[] = [
  {
    name: '光影追梦人',
    avatar: '👤',
    time: '2小时前',
    content: '找了好久的高清片源，终于在快看影视这里找到了！画质清晰、加载飞快，而且完全免费，真心推荐给所有爱看电影的朋友。',
    movie: '《流浪地球3》',
    rating: 5,
  },
  {
    name: '周末影痴',
    avatar: '👤',
    time: '5小时前',
    content: '之前用别的网站看片经常卡顿，换了快看影视之后体验天差地别。电影大全分类清晰，找片特别方便，最新电影更新速度也很快。',
    movie: '《封神第二部》',
    rating: 5,
  },
  {
    name: '深夜放映室',
    avatar: '👤',
    time: '昨天',
    content: '作为一个每天刷片的影迷，快看影视的片库丰富度让我惊喜。冷门佳作也能找到，而且播放稳定不缓冲，观影体验非常棒。',
    movie: '《奥本海默》',
    rating: 4,
  },
  {
    name: '电影日记本',
    avatar: '👤',
    time: '昨天',
    content: '朋友推荐的这个平台，试了一下确实好用。界面干净没有乱七八糟的广告，高清电影在线观看特别流畅，已经成我的主力观影站了。',
    movie: '《热辣滚烫》',
    rating: 5,
  },
  {
    name: '银幕流浪者',
    avatar: '👤',
    time: '2天前',
    content: '终于不用到处找资源了！快看影视的电影大全涵盖了我所有想看的类型，最新电影免费秒播，画质清晰不卡顿，给身边人都安利了一遍。',
    movie: '《沙丘2》',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              观众热评
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              来自真实观众的观影反馈，你的下一部好片从这里开始
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {comments.map((comment, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-200/50 transition-colors"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center text-lg flex-shrink-0">
                    {comment.avatar}
                  </div>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-foreground-900 truncate">
                      {comment.name}
                    </div>
                    <div className="text-xs text-foreground-500">{comment.time}</div>
                  </div>
                  <div className="ml-auto flex items-center gap-0.5 flex-shrink-0">
                    {Array.from({ length: comment.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-xs text-primary-500"></i>
                    ))}
                  </div>
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  {comment.content}
                </p>
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                  <i className="ri-film-line"></i>
                  {comment.movie}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}